import { PaymentErrorEnum } from '../../../types/enums.ts'

export function paymentErrorMessage(errorCode: string) {
  //GENERIC
  let message =
    'Ha habido un error al realizar el pago, vuélvalo a intentar o contáctenos.'

  if (errorCode === PaymentErrorEnum.PAYMENT) {
    message =
      'El pago se ha realizado, pero un error ha impedido que podamos proceder adecuadamente. Por favor, contáctenos para resolver este problema.'
  }

  if (errorCode === PaymentErrorEnum.NOT_AVAILABLE) {
    message = 'Lo sentimos, el coche ya ha sido reservado.'
  }

  if (errorCode === PaymentErrorEnum.PAID_NOT_AVAILABLE) {
    message =
      'Su pago se ha realizado, pero lamentablemente el coche ya no está disponible. Por favor, contáctenos para discutir las opciones disponibles.'
  }

  return message
}
